import React from 'react';
import classNames from 'classnames';
import { PopperArrowProps } from 'react-popper';
import { Placement } from 'popper.js';
import './CalloutCaret.less';

interface ICalloutCaretProps extends PopperArrowProps {
  placement?: Placement;
}

export const CALLOUT_CARET_SIZE = 16; // 1rem ~ 16px

const getCalloutCaretClassName = (placement?: Placement) => {
  // note: placement is likely to be undefined coming back from popper if there isn't room
  // for the original placement.
  return classNames('dpc-callout-caret', {
    'dpc-callout-caret--top': placement && placement.includes('top'),
    'dpc-callout-caret--left': placement && placement.includes('left'),
    'dpc-callout-caret--bottom': placement && placement.includes('bottom'),
    'dpc-callout-caret--right': placement && placement.includes('right'),
  });
};

/**
 * Caret for callout.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export const CalloutCaret = React.forwardRef(
  ({ style, placement }: ICalloutCaretProps, ref: React.Ref<HTMLDivElement>) => {
    return <div className={getCalloutCaretClassName(placement)} ref={ref} style={style} data-placement={placement} />;
  }
);
